import {createFileRoute} from "@tanstack/react-router";
import {RouteComponent} from "../-routeComponent";

export const Route = createFileRoute(
    "/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/a/_adminScaffold/workspace/$workspaceId/",
)({
    component: RouteComponent,
});
